export const getCookie = (name: string): string | undefined => {
  var r = document.cookie.match(`\\b${name}=([^;]*)\\b`);
  return r ? r[1] : undefined;
};
